<template>
  <div class="d-flex justify-content-center align-items-center" style="height: 100vh;">
    <div class="col-md-4">


      <div class="card shadow p-4 text-center" style="border-radius: 20px;">
        <img src="BEAU VOYAGE LOGOTIPO_Mesa de trabajo 1 copia.png" class="img-fluid w-50 d-block mx-auto mb-4"
          alt="" />
        <p class="text-center mb-4 fs-2">Bienvenido de nuevo</p>

        <form @submit.prevent="login">
          <div class="coolinput mb-3 w-100">
            <label for="input" class="text">Correo electrónico</label>
            <input type="email" placeholder="" class="input form-control redondo" v-model="email" id="email" required>
          </div>



          <div class="coolinput mb-3 w-100">
            <label for="input" class="text">Contraseña</label>
            <input type="password" placeholder="" class="input form-control redondo" v-model="password" id="password2"
              required>
          </div>

          <button type="submit" class="btn btn-dark w-100 redondo" :disabled="loading">
            {{ loading ? "Ingresando..." : "Continuar" }}
          </button>
        </form>
        <!-- From Uiverse.io by kyle1dev -->
        <div class="modern-success-message mt-3" v-if="successAlert">
          <button class="close-btn" @click="close">×</button>
          <div class="icon-wrapper">
            <svg stroke-linejoin="round" stroke-linecap="round" stroke-width="2" stroke="currentColor" fill="none"
              viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="success-icon">
              <path d="M9 12l2 2 4-4"></path>
              <circle r="10" cy="12" cx="12"></circle>
            </svg>
          </div>
          <div class="text-wrapper">
            <div class="title">¡Muy bien!</div>
            <div class="message">Acceso correcto</div>
          </div>
        </div>
        <div class="modern-success-message-error mt-3" v-if="error">
          <button class="close-btn" @click="close">×</button>
          <div class="icon-wrapper">
            <svg stroke-linejoin="round" stroke-linecap="round" stroke-width="2" stroke="currentColor" fill="none"
              viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="error-icon">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="15" y1="9" x2="9" y2="15"></line>
              <line x1="9" y1="9" x2="15" y2="15"></line>
            </svg>

          </div>
          <div class="text-wrapper">
            <div class="title">¡Ups!</div>
            <div class="message">{{ error }}</div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>


<script>
import axios from "axios"

export default {
  name: "LoginForm",
  data() {
    return {
      email: "",
      password: "",
      loading: false,
      error: null,
      successAlert: false
    }
  },
  mounted() {
    document.body.style.backgroundColor = "#5ca5fb";
  },
  methods: {
    async login() {
      this.loading = true
      this.error = null
      try {
        const response = await axios.post("https://beauvoyage.net/api/v1/auth/login", {
          email: this.email,
          password: this.password
        })

        // Guardar token en localStorage
        localStorage.setItem("token", response.data.access_token)

        this.successAlert = true
        setTimeout(() => {
          this.$router.push("/Dashboard")
        }, 2000);
        // Redirigir a otra vista si tienes router

      } catch (err) {
        this.error = "Credenciales incorrectas"
        setTimeout(() => {
          this.error = false
        }, 3000);
      } finally {
        this.loading = false
      }
    },
    tema() {
      this.$emit("update-estadoLogin", {
        isActive: true,
        isActive2: false,
        isActive3: true,
      });
      document.body.style.backgroundColor = "#5ca5fb";
    },
    close() {
      this.successAlert = false
      this.error = false
    }
  },
  created() {
    this.tema()
  }
}
</script>
